import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Box, Center, Text, Link as ChakraLink, VStack } from '@chakra-ui/react';
import PasswordRecoveryFormContainer from '../PasswordRecoveryForm/PasswordRecoveryFormContainer';
import AuthTitle from '../AuthTitle';

class ForgotPasswordPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      recoveryMode: true,
    };
    this.onChangeMode = this.onChangeMode.bind(this);
  }

  onChangeMode() {
    this.setState((prevState) => ({
      recoveryMode: !prevState.recoveryMode,
    }));
  }

  renderRecoveryForm() {
    return (
      <div>
        <PasswordRecoveryFormContainer />
        <VStack pt={3}>
          <ChakraLink onClick={this.onChangeMode}>
            <Text>Back to login</Text>
          </ChakraLink>
        </VStack>
        <a onClick={this.onChangeMode}></a>
      </div>
    );
  }

  render() {
    const { recoveryMode } = this.state;

    return (
      <Choose>
        <When condition={!recoveryMode}>
          <Redirect
            to={{
              pathname: `/login`,
            }}
          />
        </When>
        <Otherwise>
          <AuthTitle>
            <Center my={'30px'}>
              <Box>{this.renderRecoveryForm()}</Box>
            </Center>
          </AuthTitle>
        </Otherwise>
      </Choose>
    );
  }
}

export default ForgotPasswordPage;



// WEBPACK FOOTER //
// src/components/login/ForgotPasswordPage/index.js